import {
  ArrowLeftRightIcon,
  BellIcon,
  Building2Icon,
  CalendarIcon,
  CameraIcon,
  ChartNoAxesColumnIncreasingIcon,
  CheckCircleIcon,
  ChevronLeftIcon,
  ClockFadingIcon,
  CopyIcon,
  CopyPlusIcon,
  CreditCardIcon,
  CrownIcon,
  EllipsisIcon,
  FilePenLineIcon,
  FileSearch2Icon,
  FileTextIcon,
  GiftIcon,
  GlobeIcon,
  HelpCircleIcon,
  IdCardIcon,
  ImageIcon,
  InfoIcon,
  KeyRoundIcon,
  LandmarkIcon,
  ListFilterIcon,
  LockIcon,
  LucideIcon,
  LucideProps,
  MailIcon,
  MapPinIcon,
  MessageCircleWarningIcon,
  MessageSquareTextIcon,
  MicIcon,
  MonitorIcon,
  PanelTopIcon,
  PencilLineIcon,
  PhoneIcon,
  PlusIcon,
  RefreshCwIcon,
  SendIcon,
  ShoppingBagIcon,
  ShareIcon,
  ShieldCheckIcon,
  SparklesIcon,
  StarIcon,
  TableIcon,
  TrashIcon,
  UserCircleIcon,
  UserIcon,
  UserPlusIcon,
  UserRoundCheckIcon,
  UserRoundCogIcon,
  Users2Icon,
  XIcon,
} from 'lucide-react-native'
import { forwardRef } from 'react'

const StarFillIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>((props, _ref) => {
  const { color, ...rest } = props
  return <StarIcon {...rest} fill={color ?? 'currentColor'} stroke="none" color={color} />
})
StarFillIcon.displayName = 'StarFillIcon'

export default {
  'chevron.left': ChevronLeftIcon,
  'clock.arrow.circlepath': ClockFadingIcon,
  'plus.square.on.square': CopyPlusIcon,
  'doc.text': FileTextIcon,
  star: StarIcon,
  'star.fill': StarFillIcon,
  'person.2': Users2Icon,
  'building.columns': LandmarkIcon,
  'text.page.badge.magnifyingglass': FileSearch2Icon,
  'bubbles.and.sparkles': SparklesIcon,
  'doc.on.doc': CopyIcon,
  'square.and.arrow.up': ShareIcon,
  xmark: XIcon,
  ellipsis: EllipsisIcon,
  plus: PlusIcon,
  person: UserIcon,
  tray: BellIcon,
  trash: TrashIcon,
  'person.circle': UserCircleIcon,
  giftcard: GiftIcon,
  creditcard: CreditCardIcon,
  'chart.bar': ChartNoAxesColumnIncreasingIcon,
  'questionmark.circle': HelpCircleIcon,
  'text.bubble': MessageSquareTextIcon,
  'text.page': FileTextIcon,
  lock: LockIcon,
  'arrow.trianglehead.2.clockwise.rotate.90': RefreshCwIcon,
  'person.text.rectangle': IdCardIcon,
  phone: PhoneIcon,
  envelope: MailIcon,
  'building.2': Building2Icon,
  'person.badge.shield.checkmark': UserRoundCheckIcon,
  globe: GlobeIcon,
  paperplane: SendIcon,
  pencil: PencilLineIcon,
  tablecells: TableIcon,
  bell: BellIcon,
  'checkmark.circle': CheckCircleIcon,
  'dock.rectangle': PanelTopIcon,
  'lock.shield': ShieldCheckIcon,
  'exclamationmark.bubble': MessageCircleWarningIcon,
  'info.circle': InfoIcon,
  crown: CrownIcon,
  calendar: CalendarIcon,
  'person.badge.plus': UserPlusIcon,
  'person.badge.key': UserRoundCogIcon,
  key: KeyRoundIcon,
  'long.text.page.and.pencil': FilePenLineIcon,
  camera: CameraIcon,
  'photo.on.rectangle': ImageIcon,
  mic: MicIcon,
  location: MapPinIcon,
  desktopcomputer: MonitorIcon,
  'line.3.horizontal.decrease.circle': ListFilterIcon,
  'arrow.left.arrow.right': ArrowLeftRightIcon,
  bag: ShoppingBagIcon,
} as Record<string, LucideIcon>
